import * as React from 'react';

import CareerOutcomesModule from 'bundles/unified-description-page-common/components/modules/career-outcomes/CareerOutcomesModule';
import CareerOutcomesModuleRedesign from 'bundles/unified-description-page-common/components/modules/career-outcomes/CareerOutcomesModuleRedesign';
import DataBox from 'bundles/unified-description-page-common/components/modules/career-outcomes/DataBox';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import {
  getCareerOutcomesTitleForSpecialization,
  getCareerOutcomesValuePropsForSpecialization,
} from 'bundles/unified-description-page-common/utils/careerOutcomes';
import { SPECIALIZATION_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import careerOutcomesDataBoxImage from 'images/unified-description-page/career-outcomes-specialization.png';

type Props = { pageData: ConsumerSpecializationPageFieldsFragment };

export const SpecializationCareerOutcomesModuleRenderer = ({ pageData }: Props): React.ReactElement => {
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  const CareerOutcomesModuleComponent = enableXDPRedesign ? CareerOutcomesModuleRedesign : CareerOutcomesModule;

  return (
    <CareerOutcomesModuleComponent
      anchorId={SPECIALIZATION_NAV_ITEMS.OUTCOMES}
      title={getCareerOutcomesTitleForSpecialization()}
      valueProps={getCareerOutcomesValuePropsForSpecialization(pageData.partners?.[0]?.name)}
      imageSrc={careerOutcomesDataBoxImage}
      dataBox={
        <DataBox
          imageSrc={careerOutcomesDataBoxImage}
          careerGrowthInPercentage={pageData.careerOutcomes?.careerGrowthInPercentage}
        />
      }
    />
  );
};

export default SpecializationCareerOutcomesModuleRenderer;
